import CONFIG from '@/config/config';
import { useMemo } from 'react';

import {
  Configuration,
  RestAdminCandidatesApiFactory,
  RestAdminDashboardApiFactory,
  RestAreaOfInterestsApiFactory,
  RestAuthenticationApiFactory,
  RestDevelopmentApiFactory,
  RestDictionariesApiFactory,
  RestQuizApiFactory,
  RestSkillsApiFactory,
  RestUserApiFactory,
  RestUserProcessApiFactory,
  RestUserQuizAnswerApiFactory,
  RestUserQuizApiFactory,
} from '../generated';
import { useAxiosInstance } from './useAxiosInstance.util';

interface Return {
  adminCandidatesApi: ReturnType<typeof RestAdminCandidatesApiFactory>;
  adminDashboardApi: ReturnType<typeof RestAdminDashboardApiFactory>;
  dictionariesApi: ReturnType<typeof RestDictionariesApiFactory>;
  restAreaOfInterestsApi: ReturnType<typeof RestAreaOfInterestsApiFactory>;
  restAuthenticationApi: ReturnType<typeof RestAuthenticationApiFactory>;
  restDevelopmentApi: ReturnType<typeof RestDevelopmentApiFactory>;
  restQuizApi: ReturnType<typeof RestQuizApiFactory>;
  restSkillsApi: ReturnType<typeof RestSkillsApiFactory>;
  restUserApi: ReturnType<typeof RestUserApiFactory>;
  restUserProcessApi: ReturnType<typeof RestUserProcessApiFactory>;
  restUserQuizAnswerApi: ReturnType<typeof RestUserQuizAnswerApiFactory>;
  restUserQuizApi: ReturnType<typeof RestUserQuizApiFactory>;
}

export const useApiClient = (): Return => {
  const basePath = CONFIG.HOST;
  const configuration = getConfiguration(basePath);
  const axiosInstance = useAxiosInstance();

  return useMemo(() => {
    return {
      adminCandidatesApi: RestAdminCandidatesApiFactory(configuration, undefined, axiosInstance),
      adminDashboardApi: RestAdminDashboardApiFactory(configuration, undefined, axiosInstance),
      dictionariesApi: RestDictionariesApiFactory(configuration, undefined, axiosInstance),
      restAreaOfInterestsApi: RestAreaOfInterestsApiFactory(
        configuration,
        undefined,
        axiosInstance,
      ),
      restAuthenticationApi: RestAuthenticationApiFactory(configuration, undefined, axiosInstance),
      restDevelopmentApi: RestDevelopmentApiFactory(configuration, undefined, axiosInstance),
      restQuizApi: RestQuizApiFactory(configuration, undefined, axiosInstance),
      restSkillsApi: RestSkillsApiFactory(configuration, undefined, axiosInstance),
      restUserApi: RestUserApiFactory(configuration, undefined, axiosInstance),
      restUserProcessApi: RestUserProcessApiFactory(configuration, undefined, axiosInstance),
      restUserQuizAnswerApi: RestUserQuizAnswerApiFactory(configuration, undefined, axiosInstance),
      restUserQuizApi: RestUserQuizApiFactory(configuration, undefined, axiosInstance),
    };
  }, [axiosInstance, configuration]);
};

const getConfiguration = (basePath: string): Configuration => ({
  basePath,
  isJsonMime(_mime: string): boolean {
    return true;
  },
});
